export default __webpack_public_path__ + "static/media/home_3.a3f6f58c.webp";